import type { ApiResponse } from "../../factory";
import { BaseRepository } from "../../factory";

export interface GalleryImage {
  id: number;
  title: string;
  description: null | string;
  url: string;
  alt: null | string;
  caption: null | string;
  created_at: string;
  updated_at: string;
}

export interface Products {
  id: number;
  name: string;
  detail: string;
  main_image_id: number | null;
  video_id: number | null;
  catalog_id: number | null;
  created_at: string;
  updated_at: string;
  video: {
    data:
      | {
          id: number;
          title: string;
          type: string;
          ext: string;
          description: string | null;
          url: string;
          alt: string | null;
          caption: string | null;
          created_at: string;
          updated_at: string;
        }
      | [];
  };
  main_image: {
    data:
      | {
          id: number;
          title: string;
          description: string | null;
          url: string;
          alt: string | null;
          caption: string | null;
          created_at: string;
          updated_at: string;
        }
      | [];
  };
  cover: {
    data:
      | {
          id: number;
          title: string;
          description: string | null;
          url: string;
          alt: string | null;
          caption: string | null;
          created_at: string;
          updated_at: string;
        }
      | [];
  };
  separators: {
    type: string;
    cover_id: {
      data: {
        id: number;
        title: string;
        type: string;
        ext: string;
        description: null | string;
        url: string;
        alt: null | string;
        caption: null | string;
        created_at: string;
        updated_at: string;
      };
    };
    background_id: {
      data: {
        id: number;
        title: string;
        type: string;
        ext: string;
        description: null | string;
        url: string;
        alt: null | string;
        caption: null | string;
        created_at: string;
        updated_at: string;
      };
    };
    catalog_ids?: {
      data: {
        id: number;
        file_id: number;
        title: string;
        description: string;
        created_at: string;
        updated_at: string;
        breadcrumbs: {
          label: string;
          url: string;
        }[];
        file: {
          data:
            | {
                id: number;
                title: string;
                type: string;
                ext: string;
                description: null;
                url: string;
                alt: null | string;
                caption: null | string;
                created_at: string;
                updated_at: string;
              }
            | [];
        };
        cover: {
          data:
            | {
                id: number;
                title: string;
                type: string;
                ext: string;
                description: null | string;
                url: string;
                alt: null | string;
                caption: null | string;
                created_at: string;
                updated_at: string;
              }
            | [];
        };
        seo: {
          data: {
            id: number;
            title: null | string;
            description: null | string;
            author: null | string;
            robots: null | string;
          };
        };
      }[];
    };
    title?: string;
    description?: string;
  };
  gallery_images: { data: GalleryImage[] | [] };
}

export class ProductsRepository extends BaseRepository<Products> {
  collection = "products";
  language?: string;

  constructor(language?: string) {
    super();
    this.language = language;
  }

  getMany(
    queryParams?: Record<string, unknown>
  ): Promise<ApiResponse<Products[]>> {
    return super.getMany(queryParams);
  }

  get(
    id: number,
    queryParams?: Record<string, unknown>
  ): Promise<ApiResponse<Products>> {
    return super.get(id, queryParams);
  }
}
